module.exports = __webpack_public_path__ + "b360ede4a55c869008bf845fb0686536.fbx";